import { render, staticRenderFns } from "./ProductColors.vue?vue&type=template&id=7378d686"
import script from "./ProductColors.vue?vue&type=script&lang=js"
export * from "./ProductColors.vue?vue&type=script&lang=js"
import style0 from "./ProductColors.vue?vue&type=style&index=0&id=7378d686&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports